import type { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/admin/blacklist-auto-rules-poc/groups/:groupId',
    name: 'blacklist-rule-group-details',
    ...{ hidden: true },
    component: () => import('@/modules/blacklistAutoRules/views/RuleGroupDetails/RuleGroupDetailsPage.vue'),
    meta: {
      roles: ['advert-admin', 'manager'],
      bootstrap: false,
      layout: 'blacklist-group',
      title: 'Rule group',
    },
  },
  ...[
    { path: '/admin/blacklist-auto-rules-poc/new', name: 'blacklist-auto-rules-poc-create' },
    { path: '/admin/blacklist-auto-rules-poc/:id', name: 'blacklist-auto-rules-poc-edit' },
  ].map((route) => ({
    ...route,
    // Record-level `hidden`: the sidebar getter (`store/modules/app.js`) filters on `route.hidden`, not meta.
    hidden: true,
    component: () => import('@/modules/blacklistAutoRules/views/BlacklistAutoRuleEditor/BlacklistAutoRuleEditor.vue'),
    meta: {
      roles: ['advert-admin', 'manager'],
      bootstrap: false,
      layout: 'blacklist-editor',
      title: 'Blacklist Auto rule POC',
    },
  })),
  {
    path: '/admin/blacklist-auto-rules-poc',
    name: 'blacklist-auto-rules-poc',
    component: () => import('@/modules/blacklistAutoRules/views/BlacklistRuleGroups/BlacklistRuleGroups.vue'),
    meta: {
      roles: ['advert-admin', 'manager'],
      title: 'Blacklist Auto rules POC',
      icon: 'hp-auto-rules',
      bootstrap: false,
    },
  },
];
export default routes;
